import { useGetApiAdminIsAuthenticated, } from '../../generated/sitComponents';
export function useGetAdminIsAuthenticated(options) {
    return useGetApiAdminIsAuthenticated({}, {
        retry: (failureCount, error) => {
            const status = error?.status;
            if (!status || (status >= 400 && status < 500))
                return false;
            return failureCount < 3;
        },
        ...options,
    });
}
//# sourceMappingURL=use-get-admin-is-authenticated.js.map